// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2EDy_","footer":"ReportModalFilter_footer__36Uqd"};